<template>
  <section>
    <div class="mb-25">
      <vue-content-loading :width="600" :height="185">
        <rect x="0" y="0" rx="5" ry="5" width="290" height="185" />
        <rect x="300" y="10" rx="4" ry="4" width="300" height="40" />
        <rect x="300" y="55" rx="4" ry="4" width="150" height="40" />
        <rect x="300" y="120" rx="4" ry="4" width="300" height="10" />
        <rect x="300" y="140" rx="4" ry="4" width="250" height="10" />
        <rect x="300" y="160" rx="4" ry="4" width="290" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-25" style="width: 290px; float: left;">
      <vue-content-loading :width="290" :height="300">
        <rect x="0" y="0" rx="5" ry="5" width="290" height="185" />
        <rect x="0" y="195" rx="4" ry="4" width="290" height="35" />
        <rect x="0" y="240" rx="4" ry="4" width="250" height="10" />
        <rect x="0" y="260" rx="4" ry="4" width="150" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-25" style="margin-left: 20px; float: left; width: 290px">
      <vue-content-loading :width="290" :height="300">
        <rect x="0" y="0" rx="5" ry="5" width="290" height="185" />
        <rect x="0" y="195" rx="4" ry="4" width="290" height="35" />
        <rect x="0" y="240" rx="4" ry="4" width="250" height="10" />
        <rect x="0" y="260" rx="4" ry="4" width="150" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-10" style="width: 190px; float: left;">
      <vue-content-loading :width="190" :height="217">
        <rect x="0" y="0" rx="5" ry="5" width="190" height="115" />
        <rect x="0" y="120" rx="4" ry="4" width="190" height="30" />
        <rect x="0" y="160" rx="4" ry="4" width="150" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-10" style="width: 190px; float: left; margin-left: 15px">
      <vue-content-loading :width="190" :height="217">
        <rect x="0" y="0" rx="5" ry="5" width="190" height="115" />
        <rect x="0" y="120" rx="4" ry="4" width="190" height="30" />
        <rect x="0" y="160" rx="4" ry="4" width="150" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-10" style="width: 190px; float: left; margin-left: 15px">
      <vue-content-loading :width="190" :height="217">
        <rect x="0" y="0" rx="5" ry="5" width="190" height="115" />
        <rect x="0" y="120" rx="4" ry="4" width="190" height="30" />
        <rect x="0" y="160" rx="4" ry="4" width="150" height="10" />
      </vue-content-loading>
    </div>
    <!-- <div class="mb-10" style="width: 190px; float: left;">
      <vue-content-loading :width="190" :height="217">
        <rect x="0" y="0" rx="5" ry="5" width="190" height="115" />
        <rect x="0" y="120" rx="4" ry="4" width="190" height="30" />
        <rect x="0" y="160" rx="4" ry="4" width="150" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-10" style="width: 190px; float: left; margin-left: 15px">
      <vue-content-loading :width="190" :height="217">
        <rect x="0" y="0" rx="5" ry="5" width="190" height="115" />
        <rect x="0" y="120" rx="4" ry="4" width="190" height="30" />
        <rect x="0" y="160" rx="4" ry="4" width="150" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-10" style="width: 190px; float: left; margin-left: 15px">
      <vue-content-loading :width="190" :height="217">
        <rect x="0" y="0" rx="5" ry="5" width="190" height="115" />
        <rect x="0" y="120" rx="4" ry="4" width="190" height="30" />
        <rect x="0" y="160" rx="4" ry="4" width="150" height="10" />
      </vue-content-loading>
    </div> -->
  </section>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'HomeLogin',
  components: {
    VueContentLoading,
  },
};
</script>

<style lang="scss" scoped>
section {
  background: transparent;

  & .mb-25 {
    margin-bottom: 25px !important;
  }
  & .mb-10 {
    margin-bottom: 0px !important;
  }
}
@media all and (min-width: 300px) and (max-width: 1000px) {
  section {
    max-height: 100vh;
    min-height: 100vh !important;
    opacity: 0;
    display: none;
  }
}
</style>
